// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/messages/message_data.proto (package protos.entities.app.messages, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/messages/message_data.proto.
 */
export const file_entities_app_messages_message_data: GenFile = /*@__PURE__*/
  fileDesc("CihlbnRpdGllcy9hcHAvbWVzc2FnZXMvbWVzc2FnZV9kYXRhLnByb3RvEhxwcm90b3MuZW50aXRpZXMuYXBwLm1lc3NhZ2VzIqwBCgtNZXNzYWdlRGF0YRJCCgl0ZXh0X2RhdGEYASABKAsyLS5wcm90b3MuZW50aXRpZXMuYXBwLm1lc3NhZ2VzLk1lc3NhZ2VUZXh0RGF0YUgAElEKEXN5c3RlbV9ldmVudF9kYXRhGAIgASgLMjQucHJvdG9zLmVudGl0aWVzLmFwcC5tZXNzYWdlcy5NZXNzYWdlU3lzdGVtRXZlbnREYXRhSABCBgoEZGF0YSI3Cg9NZXNzYWdlVGV4dERhdGESDAoEdGV4dBgBIAEoCRIWCg5pc190ZXh0X2VkaXRlZBgCIAEoCCLmAQoWTWVzc2FnZVN5c3RlbUV2ZW50RGF0YRJcChFjaGF0X21lbWJlcl9hZGRlZBgBIAEoCzI/LnByb3Rvcy5lbnRpdGllcy5hcHAubWVzc2FnZXMuTWVzc2FnZVN5c3RlbUV2ZW50Q2hhdE1lbWJlckFkZGVkSAASYAoTY2hhdF9tZW1iZXJfcmVtb3ZlZBgCIAEoCzJBLnByb3Rvcy5lbnRpdGllcy5hcHAubWVzc2FnZXMuTWVzc2FnZVN5c3RlbUV2ZW50Q2hhdE1lbWJlclJlbW92ZWRIAEIMCgpldmVudF9kYXRhIrACCiFNZXNzYWdlU3lzdGVtRXZlbnRDaGF0TWVtYmVyQWRkZWQSVwoHbWVtYmVycxgBIAMoCzJGLnByb3Rvcy5lbnRpdGllcy5hcHAubWVzc2FnZXMuTWVzc2FnZVN5c3RlbUV2ZW50Q2hhdE1lbWJlckFkZGVkLk1lbWJlchJZCghhZGRlZF9ieRgCIAEoCzJHLnByb3Rvcy5lbnRpdGllcy5hcHAubWVzc2FnZXMuTWVzc2FnZVN5c3RlbUV2ZW50Q2hhdE1lbWJlckFkZGVkLkFkZGVkQnkaKgoGTWVtYmVyEhIKCmFjY291bnRfaWQYASABKAkSDAoEbmFtZRgCIAEoCRorCgdBZGRlZEJ5EhIKCmFjY291bnRfaWQYASABKAkSDAoEbmFtZRgCIAEoCSK8AgojTWVzc2FnZVN5c3RlbUV2ZW50Q2hhdE1lbWJlclJlbW92ZWQSWQoHbWVtYmVycxgBIAMoCzJILnByb3Rvcy5lbnRpdGllcy5hcHAubWVzc2FnZXMuTWVzc2FnZVN5c3RlbUV2ZW50Q2hhdE1lbWJlclJlbW92ZWQuTWVtYmVyEl8KCnJlbW92ZWRfYnkYAiABKAsySy5wcm90b3MuZW50aXRpZXMuYXBwLm1lc3NhZ2VzLk1lc3NhZ2VTeXN0ZW1FdmVudENoYXRNZW1iZXJSZW1vdmVkLlJlbW92ZWRCeRoqCgZNZW1iZXISEgoKYWNjb3VudF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJGi0KCVJlbW92ZWRCeRISCgphY2NvdW50X2lkGAEgASgJEgwKBG5hbWUYAiABKAliBnByb3RvMw");

/**
 * @generated from message protos.entities.app.messages.MessageData
 */
export type MessageData = Message<"protos.entities.app.messages.MessageData"> & {
  /**
   * @generated from oneof protos.entities.app.messages.MessageData.data
   */
  data: {
    /**
     * @generated from field: protos.entities.app.messages.MessageTextData text_data = 1;
     */
    value: MessageTextData;
    case: "textData";
  } | {
    /**
     * @generated from field: protos.entities.app.messages.MessageSystemEventData system_event_data = 2;
     */
    value: MessageSystemEventData;
    case: "systemEventData";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.entities.app.messages.MessageData.
 * Use `create(MessageDataSchema)` to create a new message.
 */
export const MessageDataSchema: GenMessage<MessageData> = /*@__PURE__*/
  messageDesc(file_entities_app_messages_message_data, 0);

/**
 * @generated from message protos.entities.app.messages.MessageTextData
 */
export type MessageTextData = Message<"protos.entities.app.messages.MessageTextData"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: bool is_text_edited = 2;
   */
  isTextEdited: boolean;
};

/**
 * Describes the message protos.entities.app.messages.MessageTextData.
 * Use `create(MessageTextDataSchema)` to create a new message.
 */
export const MessageTextDataSchema: GenMessage<MessageTextData> = /*@__PURE__*/
  messageDesc(file_entities_app_messages_message_data, 1);

/**
 * @generated from message protos.entities.app.messages.MessageSystemEventData
 */
export type MessageSystemEventData = Message<"protos.entities.app.messages.MessageSystemEventData"> & {
  /**
   * @generated from oneof protos.entities.app.messages.MessageSystemEventData.event_data
   */
  eventData: {
    /**
     * @generated from field: protos.entities.app.messages.MessageSystemEventChatMemberAdded chat_member_added = 1;
     */
    value: MessageSystemEventChatMemberAdded;
    case: "chatMemberAdded";
  } | {
    /**
     * @generated from field: protos.entities.app.messages.MessageSystemEventChatMemberRemoved chat_member_removed = 2;
     */
    value: MessageSystemEventChatMemberRemoved;
    case: "chatMemberRemoved";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.entities.app.messages.MessageSystemEventData.
 * Use `create(MessageSystemEventDataSchema)` to create a new message.
 */
export const MessageSystemEventDataSchema: GenMessage<MessageSystemEventData> = /*@__PURE__*/
  messageDesc(file_entities_app_messages_message_data, 2);

/**
 * @generated from message protos.entities.app.messages.MessageSystemEventChatMemberAdded
 */
export type MessageSystemEventChatMemberAdded = Message<"protos.entities.app.messages.MessageSystemEventChatMemberAdded"> & {
  /**
   * @generated from field: repeated protos.entities.app.messages.MessageSystemEventChatMemberAdded.Member members = 1;
   */
  members: MessageSystemEventChatMemberAdded_Member[];

  /**
   * @generated from field: protos.entities.app.messages.MessageSystemEventChatMemberAdded.AddedBy added_by = 2;
   */
  addedBy?: MessageSystemEventChatMemberAdded_AddedBy | undefined;
};

/**
 * Describes the message protos.entities.app.messages.MessageSystemEventChatMemberAdded.
 * Use `create(MessageSystemEventChatMemberAddedSchema)` to create a new message.
 */
export const MessageSystemEventChatMemberAddedSchema: GenMessage<MessageSystemEventChatMemberAdded> = /*@__PURE__*/
  messageDesc(file_entities_app_messages_message_data, 3);

/**
 * @generated from message protos.entities.app.messages.MessageSystemEventChatMemberAdded.Member
 */
export type MessageSystemEventChatMemberAdded_Member = Message<"protos.entities.app.messages.MessageSystemEventChatMemberAdded.Member"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message protos.entities.app.messages.MessageSystemEventChatMemberAdded.Member.
 * Use `create(MessageSystemEventChatMemberAdded_MemberSchema)` to create a new message.
 */
export const MessageSystemEventChatMemberAdded_MemberSchema: GenMessage<MessageSystemEventChatMemberAdded_Member> = /*@__PURE__*/
  messageDesc(file_entities_app_messages_message_data, 3, 0);

/**
 * @generated from message protos.entities.app.messages.MessageSystemEventChatMemberAdded.AddedBy
 */
export type MessageSystemEventChatMemberAdded_AddedBy = Message<"protos.entities.app.messages.MessageSystemEventChatMemberAdded.AddedBy"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message protos.entities.app.messages.MessageSystemEventChatMemberAdded.AddedBy.
 * Use `create(MessageSystemEventChatMemberAdded_AddedBySchema)` to create a new message.
 */
export const MessageSystemEventChatMemberAdded_AddedBySchema: GenMessage<MessageSystemEventChatMemberAdded_AddedBy> = /*@__PURE__*/
  messageDesc(file_entities_app_messages_message_data, 3, 1);

/**
 * @generated from message protos.entities.app.messages.MessageSystemEventChatMemberRemoved
 */
export type MessageSystemEventChatMemberRemoved = Message<"protos.entities.app.messages.MessageSystemEventChatMemberRemoved"> & {
  /**
   * @generated from field: repeated protos.entities.app.messages.MessageSystemEventChatMemberRemoved.Member members = 1;
   */
  members: MessageSystemEventChatMemberRemoved_Member[];

  /**
   * @generated from field: protos.entities.app.messages.MessageSystemEventChatMemberRemoved.RemovedBy removed_by = 2;
   */
  removedBy?: MessageSystemEventChatMemberRemoved_RemovedBy | undefined;
};

/**
 * Describes the message protos.entities.app.messages.MessageSystemEventChatMemberRemoved.
 * Use `create(MessageSystemEventChatMemberRemovedSchema)` to create a new message.
 */
export const MessageSystemEventChatMemberRemovedSchema: GenMessage<MessageSystemEventChatMemberRemoved> = /*@__PURE__*/
  messageDesc(file_entities_app_messages_message_data, 4);

/**
 * @generated from message protos.entities.app.messages.MessageSystemEventChatMemberRemoved.Member
 */
export type MessageSystemEventChatMemberRemoved_Member = Message<"protos.entities.app.messages.MessageSystemEventChatMemberRemoved.Member"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message protos.entities.app.messages.MessageSystemEventChatMemberRemoved.Member.
 * Use `create(MessageSystemEventChatMemberRemoved_MemberSchema)` to create a new message.
 */
export const MessageSystemEventChatMemberRemoved_MemberSchema: GenMessage<MessageSystemEventChatMemberRemoved_Member> = /*@__PURE__*/
  messageDesc(file_entities_app_messages_message_data, 4, 0);

/**
 * @generated from message protos.entities.app.messages.MessageSystemEventChatMemberRemoved.RemovedBy
 */
export type MessageSystemEventChatMemberRemoved_RemovedBy = Message<"protos.entities.app.messages.MessageSystemEventChatMemberRemoved.RemovedBy"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message protos.entities.app.messages.MessageSystemEventChatMemberRemoved.RemovedBy.
 * Use `create(MessageSystemEventChatMemberRemoved_RemovedBySchema)` to create a new message.
 */
export const MessageSystemEventChatMemberRemoved_RemovedBySchema: GenMessage<MessageSystemEventChatMemberRemoved_RemovedBy> = /*@__PURE__*/
  messageDesc(file_entities_app_messages_message_data, 4, 1);

